/**
 * @generated SignedSource<<bd7a33c8747e560636094f7a4e4c26c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubProfileModelStatusChoices = "ACTIVE" | "ARCHIVED" | "%future added value";
export type ArchivePupilsInput = {
  block: number;
  clientMutationId?: string | null | undefined;
  pupilIds: ReadonlyArray<string | null | undefined>;
  startingYear: number;
};
export type ArchivePupilsMutation$variables = {
  input: ArchivePupilsInput;
};
export type ArchivePupilsMutation$data = {
  readonly archivePupils: {
    readonly archivedParents: ReadonlyArray<{
      readonly id: string;
      readonly status: PianofunclubProfileModelStatusChoices;
    } | null | undefined> | null | undefined;
    readonly archivedPupils: ReadonlyArray<{
      readonly id: string;
      readonly status: PianofunclubProfileModelStatusChoices;
    } | null | undefined> | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
    readonly vacatedLessonBlocks: ReadonlyArray<{
      readonly id: string;
      readonly pupil: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ArchivePupilsMutation = {
  response: ArchivePupilsMutation$data;
  variables: ArchivePupilsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchivePupilsPayload",
    "kind": "LinkedField",
    "name": "archivePupils",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "archivedPupils",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "archivedParents",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LessonBlockNode",
        "kind": "LinkedField",
        "name": "vacatedLessonBlocks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "pupil",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchivePupilsMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchivePupilsMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f3bdaf874c8ce3baee563d6ad7ca89a5",
    "id": null,
    "metadata": {},
    "name": "ArchivePupilsMutation",
    "operationKind": "mutation",
    "text": "mutation ArchivePupilsMutation(\n  $input: ArchivePupilsInput!\n) {\n  archivePupils(input: $input) {\n    success\n    errors\n    archivedPupils {\n      id\n      status\n    }\n    archivedParents {\n      id\n      status\n    }\n    vacatedLessonBlocks {\n      id\n      pupil {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6db0a39b8c1a677ad85ec9c3b074f3c5";

export default node;
